<template>
  <div class="partner partner-component wd-1200">
    <div>
      <moduleTitle :large="large" :moduleFlag="moduleFlag" />
    </div>
    <div class="partner-content" v-if="moduleInfo && moduleInfo.pcImage">
      <img :src="moduleInfo.pcImage"/>
    </div>
  </div>
</template>

<script>
  import moduleTitle from '@/components/pc/module-title';

  export default {
    components: { moduleTitle },
    props: {
      moduleInfo: {
        type: Object,
        default: () => {}
      },
      moduleFlag: {
        type: String,
        default: '',
      },
      large: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    created() {
      console.log('partner', this.moduleInfo)
    }
  }
</script>

<style scoped lang="scss">
  .partner {
    .partner-content {
      min-height: 270px;
      padding-bottom: 20px;

      img {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    }
  }
</style>
